import React, { Component, createRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./course.css";

const courseResource = [
  { name: "INTERNAL LOCKDOWN PROCEDURES", img: "lockdown.jpg" },
  { name: "ACTIVE SHOOTER INTERNAL THREAT", img: "activeShooterInt.jpg" },
  { name: "ACTIVE SHOOTER EXTERNAL THREAT", img: "activeShooterExt.jpg" },
  { name: "COMBATIVE PARENT EXTERNAL THREAT", img: "combativeExt.jpg" },
  { name: "COMBATIVE PARENT INTERNAL THREAT", img: "combativeParentInt.jpg" },
  { name: "SHELTER AND PLACE", img: "shelterAndPlace.jpg" },
];

class Course extends Component {
  render() {
    const responsive = {
      desktop: {
        breakpoint: { max: 3000, min: 1300 },
        items: 3,
        slidesToSlide: 1,
      },
      tablet: {
        breakpoint: { max: 1300, min: 850 },
        items: 2,
        slidesToSlide: 1,
      },
      mobile: {
        breakpoint: { max: 850, min: 0 },
        items: 1,
        slidesToSlide: 1,
      },
    };

    return (
      <div className="course">
        <h2 className="course__title">Courses Included</h2>
        <Carousel
          responsive={responsive}
          autoPlaySpeed={1000}
          transitionDuration={500}
          infinite={true}
          arrows={true}
          customLeftArrow={<button className="custom-arrow left">{"<-"}</button>}
          customRightArrow={<button className="custom-arrow right">{"->"}</button>}
        >
          {courseResource.map((resource, index) => (
            <div className="courseListItem" key={index}>
              <p className="courseListText">{resource.name}</p>
              <img
                src={require(`../../assets/img/certifcates/${resource.img}`)}
                className="courseListImg"
              ></img>
            </div>
          ))}
        </Carousel>
      </div>
    );
  }
}

export default Course;
